import { Button, type ButtonProps } from '@chakra-ui/react';
import type React from 'react';

export interface FaceliftButtonProps extends ButtonProps {
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
	sx?: React.CSSProperties;
	buttonKey?: string;
	bg?: string | { _dark: string; _light: string };
	color?: string | { _dark: string; _light: string };
	startIcon?: React.ReactNode;
	endIcon?: React.ReactNode;
	ref?: React.RefObject<HTMLButtonElement | null>;
}

const FaceliftButton: React.FC<FaceliftButtonProps> = ({
	onClick,
	sx,
	buttonKey,
	bg = 'brand.solidGradient',
	color = 'brand.muted',
	startIcon,
	endIcon,
	children,
	size = 'xs',
	ref,
	...rest
}) => {
	return (
		<Button
			ref={ref}
			bg={bg}
			color={color}
			key={buttonKey}
			onClick={onClick}
			borderRadius={20}
			spinner={<span className="tripple-dot-loader"></span>}
			{...(startIcon || endIcon
				? {
					display: 'inline-flex',
					alignItems: 'center',
				}
				: {})}
			size={size}
			style={sx}
			{...rest}
		>
			{startIcon}
			{children}
			{endIcon}
		</Button>
	);
};

export default FaceliftButton;
